type WebViewWindow = Window & {
  ReactNativeWebView: {
    postMessage: (data: unknown) => void;
    injectedObjectJson: () => string;
  };
};

export const getTacticAppAuthToken = () => {
  if (typeof window !== "undefined") {
    return JSON.parse(
      //@ts-ignore
      (window as WebViewWindow).ReactNativeWebView?.injectedObjectJson()
    )?.authToken;
  }
};
